import { Injectable, Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe regarding the displaying of customer names abreviated.
 * requires an import in the decorator.
 * usage only inside the html template. NO TS CODE.
 * for ts code useage @see UsernameAbbreviationService
 */
@Pipe({
  name: 'usernameAbbreviation',
  standalone: true
})
export class UsernameAbbreviationPipe implements PipeTransform {

  public transform(username: string | undefined): string {
    return UsernameAbbreviationService.transform(username);
  }

}

/**
 * Pipe regarding the displaying of customer names abreviated.
 * no import required.
 * no instance required.
 * usage only inside the ts code. NO HTML TEMPLATE.
 * for html template usage @see UsernameAbbreviationPipe
 */
@Injectable({
  providedIn: 'root'
})
export class UsernameAbbreviationService {

  public static transform(username: string | undefined): string {
    username = username?.trim();
    if (username == undefined || username.length <= 0) { return ''; }

    let nameSplit = username.split(" ");

    return nameSplit[nameSplit.length - 1];
  }

}
